<script>
import { vodafoneLabBasicMixin } from '../../modules/vodafone_lab_mixins_module.js';

export default {
  mixins: [vodafoneLabBasicMixin],
  props: {
    col: {
      type: Number,
      default: 8
    },
    content: {
      type: Object,
      required: true
    },
    align: String
  },
  methods: {
    alignTextToJustify: Fandom.alignTextToJustify,
    getTarget: Fandom.getTarget,
  },
  computed: {
    columnClasses() {
      const columnWidth = Fandom.exists(this.content.width) ? this.content.width : this.col;
      return [
        `col-md-${columnWidth}`
      ];
    },
    isValid() {
      return this.content.title ||
             this.content.subtitle ||
             this.content.description;
    }
  }
};
</script>

<template>
  <div class="container" v-if="isValid" stripe-header-component>
    <div class="row" :class="`justify-content-md-${alignTextToJustify(align)}`">
      <div :class="[columnClasses, `text-${align ? align : 'center'}`]">
        <p class="category" v-if="content.category">{{content.category}}</p>
        <component v-if="content.title" :is="content.title_tag || 'h2'" :class="content.title_class || 'h2'">{{content.title}}</component>
        <component v-if="content.subtitle" :is="content.subtitle_tag || 'h3'" :class="content.subtitle_class || 'h3'">{{content.subtitle}}</component>
        <component v-if="content.description" :is="content.description_tag || 'p'" class="mb-1" v-html="content.description"></component>
      </div>
      <div class="col align-self-end d-flex justify-content-md-end" v-if="content.url">
        <p><a class="font-weight-normal" :href="content.url.url" :target="getTarget(content.url)">{{content.url.title}}</a></p>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
</style>
